<script setup>
import {Permissions} from "@/Utils/Permissions";
import ClientInvoiceByAgeReport from "@/Components/Reports/ClientInvoiceByAgeReport.vue";
</script>

<template>
  <v-row v-if="Permissions.checkPermissions(['dashboards.aging-receivables'])">
    <v-col cols="12">
      <ClientInvoiceByAgeReport/>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>